export const IconPencil = ({ size = 24, color = 'currentColor' }) => (
  <svg
    width={size}
    height={size}
    viewBox="6 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.1956 2.23627C23.4936 1.92771 23.8501 1.6816 24.2443 1.51228C24.6384 1.34297 25.0623 1.25385 25.4913 1.25012C25.9203 1.24639 26.3457 1.32813 26.7427 1.49057C27.1397 1.65301 27.5004 1.8929 27.8038 2.19623C28.1071 2.49956 28.347 2.86026 28.5094 3.2573C28.6719 3.65433 28.7536 4.07974 28.7499 4.5087C28.7462 4.93766 28.657 5.36158 28.4877 5.75573C28.3184 6.14988 28.0723 6.50636 27.7637 6.80437L13.8947 20.6734H9.32656V16.1053L23.1956 2.23627Z"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
